export default "__VITE_ASSET__BMmjwLZX__"